import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoaderSubjectService } from 'app/shared/ui-commons/ui-spinner/util-commons/service/loader-subject.service';

export function errorHandlerInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const loader = inject(LoaderSubjectService);

  return next(request).pipe(
    catchError((exception: CustomHttpErrorResponse) => {
      loader.closeLoader();
      const body = exception?.error?.error;
      if (body?.code && body?.code === '126.01.01' && exception?.status === 400) {
        router.navigate(['/outschedule']);
      } else {
        router.navigate(['/error']);
      }
      return throwError(() => undefined);
    })
  );
}

interface CustomHttpErrorResponse extends HttpErrorResponse {
  code: string;
}
